module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-copyright element-without-heading",
    attrs: {
      "epub:type": "copyright-page",
      "id": "copyright"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "copyright-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center copyright-content"
  }, [_vm._v("Trail Marked © Copyright 2021 Heather Hambel Curley & Rebecca Hamilton")])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width copyright-content"
  }, [_vm._v("Copyright notice: All rights reserved under the International and Pan-American Copyright Conventions. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system, without permission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("This is a work of fiction. Names, places, characters and incidents are either the product of the author’s imagination or are used fictitiously, and any resemblance to any actual persons, living or dead, organizations, events or locales is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq copyright-content"
  }, [_vm._v("Warning: the unauthorized reproduction or distribution of this copyrighted work is illegal. Criminal copyright infringement, including infringement without monetary gain, is investigated by the FBI and is punishable by up to 5 years in prison and a fine of $250,000.")]), _vm._v(" "), _c('p', {
    staticClass: "created-with-vellum"
  }, [_c('a', {
    attrs: {
      "href": "http://tryvellum.com/created",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "created-with-vellum-image-decorator"
  }, [_c('span', {
    staticClass: "created-with-vellum-image-size-container"
  }, [_c('img', {
    staticClass: "created-with-vellum-image",
    attrs: {
      "alt": "Vellum flower icon",
      "src": "images/vellum-created.svg"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "created-with-vellum-text"
  }, [_vm._v("Created with Vellum")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8673887c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 60
// module chunks = 0